<template>
    <div class="popover" v-if="showNotice">
        <div class="popover__text">Ваш город - {{ value }}?</div>
        <div class="city-msg__actions">
            <button class="city-msg__action r-button button button-city_choose-yes" type="button" @click="closeModal()">Да</button>
            <button class="city-msg__action r-button button button-city_choose-no" type="button" @click="openCitiesModal()">Выбрать другой город</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CityNotification",
        props: {
            value: {
                required: true
            },
            hideMessage: {
                default: false,
            }
        },
        data() {
            return {
                showNotice: true
            }
        },
        mounted() {
            if (this.hideMessage) {
                this.$cookie.setCookie('city-chosen', true, 31);
            }

            let cityChosen = this.$cookie.getCookie('city-chosen');

            if (cityChosen) {
                this.showNotice = false;
            } else {
                MenuEvent.$on('cityNotificationClose', () => {
                    this.$cookie.setCookie('city-chosen', true, 31);
                    this.showNotice = false;
                });
            }
        },
        methods: {
            closeModal() {
                MenuEvent.$emit('cityNotificationClose');
            },
            openCitiesModal() {
                MenuEvent.$emit('openCitiesModal');
            },
        }
    }
</script>
